import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { useInactive } from "~/hooks/use-inactive";
import { DEFAULT_COUNTDOWN_MS } from "~/utils/constants";
import { DialogStandBy } from "~/components/DialogStandBy";
import { basketActions } from "~/providers/store/basket";
import {
  employeeActions,
  useIsEmployeeAuthenticated
} from "~/providers/store/employee";
import { useDiningOption } from "~/providers/store/basket/hooks/use-basket";
import { hasAttendedSellConfig } from "~/utils/tills/has-attended-sell-config";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useBasketContext } from "~/providers/store/basket/context";

export const DialogInactive = () => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const { pathname } = useLocation();

  const { data: till } = useCurrentTill();
  const diningOption = useDiningOption();
  const isEmpty = useBasketContext((state) => state.isBasketEmpty);
  const isAuthenticated = useIsEmployeeAuthenticated();

  const isDisabled = useMemo(() => {
    if (hasAttendedSellConfig(till)) {
      return true;
    }

    if (isDialogVisible) {
      return true;
    }

    // shopper is not authenticated and basket is empty
    if (!isAuthenticated && !diningOption && isEmpty) {
      return true;
    }

    return false;
  }, [till, isDialogVisible, isAuthenticated, diningOption, isEmpty]);

  useInactive({
    inactiveTimeout: DEFAULT_COUNTDOWN_MS,
    disabled: isDisabled,
    onInactive: () => {
      if (isPaymentInProgress(pathname)) {
        return;
      }
      setIsDialogVisible(true);
    }
  });

  if (!isDialogVisible) {
    return null;
  }

  return (
    <DialogStandBy
      onCancelSession={() => {
        basketActions.reset();
        basketActions.resetDiningOption();
        employeeActions.reset();
        setIsDialogVisible(false);
      }}
      onContinueSession={() => {
        setIsDialogVisible(false);
      }}
    />
  );
};

function isPaymentInProgress(pathname: string) {
  return (
    pathname.includes("card") ||
    pathname.includes("cash") ||
    pathname.includes("billing") ||
    pathname.includes("mobilepay") ||
    pathname.includes("credit") ||
    pathname.includes("home") ||
    pathname.includes("settings")
  );
}
